/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { TRANSFER_BOX_AMOUNT } from "../graphql/transferBoxAmount.mutation";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ITransferBoxAmountMethods extends IPluginMethodMap {
  TransferBoxAmount(args: any): Promise<any>;
}

export class TransferBoxAmountService implements IAgentPlugin {
  readonly methods: ITransferBoxAmountMethods;

  constructor() {
    this.methods = {
      TransferBoxAmount: this.TransferBoxAmount.bind(this),
    };
  }

  async TransferBoxAmount(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.mutate({
          mutation: TRANSFER_BOX_AMOUNT,
          variables: {
            boxId: args?.payload?.boxId,
            toCostumeValueId: args?.payload?.toCostumeValueId,
            amount: parseFloat(args?.payload?.amount),
            fromCostumeValueId: args?.payload?.fromCostumeValueId,
            reason: args?.payload?.reason,
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
